import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';
import s from './Sheet.module.scss';

const Sheet = ({
    modifier,
    layoutCode,
    images,
    text,
    acknowledgement,
    firstName,
    lastName,
    honoredBy,
    preview,
}) => {
    const imageObj = images.find((item) => item.layoutCode === layoutCode);
    if (!imageObj) {
        return null;
    }

    let style = {};
    const imageSrc = _.get(imageObj, 'image.src', '');
    if(!_.isEmpty(imageSrc)) {
        style.backgroundImage = `url(${imageSrc})`;
    }

    return (
        <div className={classNames(s['Sheet'], {
            [s['Sheet--Preview']]: preview,
            [s[`Sheet--${modifier}`]]: modifier,
        })} style={style}>
            <div className={s['Sheet__Container']}>
                <div className={s['Sheet__Content']}>
                    <h2 className={s['Sheet__Name']}>
                        {firstName} {lastName}
                    </h2>
                    <div className={s['Sheet__Text']}>{text}</div>
                    {honoredBy &&
                        <ul className={s['Sheet__HonoredBy']}>
                            {honoredBy.map((item, index) => (
                                <li key={index}>{item.name}</li>
                            ))}
                        </ul>
                    }
                    <p className={s['Sheet__Acknowledgement']}>{acknowledgement}</p>
                </div>
            </div>
        </div>
    );
};

Sheet.propTypes = {
    modifier: PropTypes.string,
    layoutCode: PropTypes.string,
    images: PropTypes.array,
    text: PropTypes.string,
    acknowledgement: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    honoredBy: PropTypes.array,
    preview: PropTypes.bool,
};

Sheet.defaultProps = {
    modifier: '',
    images: [],
    layoutCode: '',
    text: '',
    acknowledgement: '',
    firstName: '',
    lastName: '',
    honoredBy: [],
    preview: false,
};

export default Sheet;
